import React from "react"

import SEO from "../../../components/seo"
import Layout from "../../../components/layout"
import CustomNavTitle from "../../../components/CustomNavTitle"
import DefaultLayoutSidebar from "../../../components/DefaultLayoutSidebar"

import illustration2x from "../../../images/illustrations/illustration-requirements-iut@2x.png"

import { theme } from "../../../styles/theme"

const ExchangeTransfusion = ({ location }) => {
  return (
    <Layout>
      <SEO title="Specific Requirements - Exchange Transfusion (ET) for neonates" />

      <CustomNavTitle
        title="Specific Requirements"
        destination="/requirements/irradiation/"
        location={location}
      />

      <DefaultLayoutSidebar>
        <section className="theme max-w-content">
          <h3 css={[theme.components.title, theme.components.titleRed]}>
            Exchange blood transfusion (EBT) for neonates
          </h3>

          <h4
            className="mt-gap-2"
            css={[theme.components.title, theme.components.titleSmall]}
          >
            Indication for irradiated components
          </h4>
          <p>
            Neonatal EBT if there has been a previous IUT or if the donation is
            from a first or second degree relative. For other neonatal EBT,
            irradiation is recommended unless it causes a clinically significant
            delay in provision. It is recommended that red cells are transfused
            within 24 hours of irradiation.
          </p>

          <h4
            className="mt-gap-2"
            css={[theme.components.title, theme.components.titleSmall]}
          >
            Duration of requirement
          </h4>
          <p>6 months post expected delivery date.</p>
        </section>
        <aside>
          <img src={illustration2x} alt="Illustration" />
        </aside>
      </DefaultLayoutSidebar>
    </Layout>
  )
}

export default ExchangeTransfusion
